import axios, { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { ISupportCaseDuplicate } from '../../models';
import { queryKeys } from '../../../shared';

async function getSupportCaseDuplicates(
    id: string,
    includeMarkedAsNoDuplicate?: boolean,
    onGetErrorMessage?: string,
): Promise<ISupportCaseDuplicate[]> {
    const { data } = await axios.get(`/support-api/support-cases/${id}/duplicates`, {
        errorMessage: onGetErrorMessage,
        params: { includeMarkedAsNoDuplicate },
    });
    return data;
}

export const useSupportCaseDuplicates = (id: string, includeMarkedAsNoDuplicate?: boolean) => {
    const { t } = useTranslation();

    return useQuery<ISupportCaseDuplicate[], AxiosError>({
        queryKey: [queryKeys.SUPPORT_CASES_DUPLICATES, id, includeMarkedAsNoDuplicate],
        queryFn: () => getSupportCaseDuplicates(id, includeMarkedAsNoDuplicate, t('getSupportCaseDuplicatesError')),
    });
};
